import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { setAppSettings } from '../app.actions';
import { AppState } from '../reducers';
import { ConfigService } from './config.service';

@Injectable()
export class AppConfigService {
  constructor(
    private configService: ConfigService,
    private store: Store<AppState>,
  ) {}

  load(): Promise<void> {
    const keys = [
      ConfigService.TRADING_ADDRESS_AVAILABILITY_FEED_ID,
      ConfigService.ENVIRONMENT,
      ConfigService.ALLOWED_ADDRESSES_FOR_STUDY_ACCESS,
      ConfigService.LISTED_UNLISTED_FILTER_AVAILABILITY_FEED_ID,
      ConfigService.TRADING_ADDRESS_AVAILABILITY_TPCORBIS_FEED_ID,
      ConfigService.IS_GENERATIVE_AI_ENABLED,
    ];

    return firstValueFrom(this.configService.getConfigValues(keys))
      .then((appSettings) => {
        this.store.dispatch(setAppSettings({ appSettings }));
      })
      .catch(function (ex) {
        console.error(ex);
      });
  }
}
